import Api from "api/Api";
import type { ApiResponse } from "api/types";
import type { AxiosPromise } from "axios";
import { GIT_BASE_URL } from "git/requests/constants";

export type GenerateCDApiKeyResponseData = string;

export type GenerateCDApiKeyResponse =
  ApiResponse<GenerateCDApiKeyResponseData>;

export default async function generateCDApiKeyRequest(
  baseApplicationId: string,
): AxiosPromise<GenerateCDApiKeyResponse> {
  return Api.post(
    `${GIT_BASE_URL}/applications/${baseApplicationId}/bearer-token`,
  );
}
